import { render, staticRenderFns } from "./BatteryInfo.vue?vue&type=template&id=0688acf8&scoped=true&"
import script from "./BatteryInfo.vue?vue&type=script&lang=js&"
export * from "./BatteryInfo.vue?vue&type=script&lang=js&"
import style0 from "./BatteryInfo.vue?vue&type=style&index=0&id=0688acf8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0688acf8",
  null
  
)

export default component.exports